import { render, staticRenderFns } from "./EmployeeFormSection.vue?vue&type=template&id=c40c359c"
import script from "./EmployeeFormSection.vue?vue&type=script&lang=js"
export * from "./EmployeeFormSection.vue?vue&type=script&lang=js"
import style0 from "./EmployeeFormSection.vue?vue&type=style&index=0&id=c40c359c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports